import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"

import { z } from "zod"
import type { TypedSchemaOutput } from "@/utils/utilityTypes"

const productFormSchema = z.object({
  name: z
    .string()
    .min(1, { message: "Product name is required" }),
  price: z.number().int().nonnegative(),
  color: z.string().nullable(),
  vatRate: z.number().nullable(),
  parentCategoryId: z.string().uuid().nullable(),
  hasVariablePrice: z.boolean(),
  tagIds: z.array(z.string().uuid()),
  modifierGroupIds: z.array(z.string().uuid()),
})

export type CreateUpdateProductFormOutput =
  TypedSchemaOutput<typeof productFormSchema>

export const useCreateUpdateProductForm = () =>
  useForm({
    validationSchema: toTypedSchema(productFormSchema),
    initialValues: {
      name: "",
      price: 0,
      color: null,
      parentCategoryId: null,
      vatRate: null,
      hasVariablePrice: false,
      tagIds: [],
      modifierGroupIds: [],
    },
  })
